var exports = {
  "A4": "VoiceSceneAmbienceControl.module__control___V3BVa0",
  "Kk": "VoiceSceneAmbienceControl.module__icon___V3BVa0",
  "Pf": "VoiceSceneAmbienceControl.module__label___V3BVa0",
  "aw": "VoiceSceneAmbienceControl.module__slider___V3BVa0",
};

module.exports = exports;
